import { priceFormat } from "@tradingApp/helpers/price";

export function tradingAssetChartPriceFormat(
  value: number,
  currency?: string,
): string {
  const [, fraction] = String(value).split(".");
  const fractionLength = fraction?.length ?? 0;
  const minimumFractionDigits = fractionLength < 2 ? 2 : fractionLength;

  return priceFormat({
    price: value,
    currency,
    options: { minimumFractionDigits },
  });
}
